// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5f2e7703","577":"398596b9","951":"f5673777"}[chunkId] + ".chunk.js";
};